import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  VStack,
  Divider,
  Box,
  Wrap,
  WrapItem,
  Tag,
  TagLabel,
  TagCloseButton,
  Text,
} from '@chakra-ui/react';
import TaskForm from '../../Forms/TaskForm';

interface TaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  isLoading: boolean;
  projectName?: string;
  taskFormData: any;
  setTaskFormData: (data: any) => void;
  users: any[];
  getSelectedUserNames: () => string[];
  handleUserToggle: (userId: string) => void;
  formatDateForInput: (date: Date | string | undefined | null) => string;
}

const TaskModal: React.FC<TaskModalProps> = ({
  isOpen,
  onClose,
  onSave,
  isLoading,
  projectName,
  taskFormData,
  setTaskFormData,
  users,
  getSelectedUserNames,
  handleUserToggle,
  formatDateForInput,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} size="6xl">
    <ModalOverlay />
    <ModalContent maxH="90vh" overflowY="auto">
      <ModalHeader>Add Task to "{projectName}"</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <VStack spacing={4}>
          <TaskForm
            formData={taskFormData}
            onFormChange={data => setTaskFormData((prev: any) => ({ ...prev, ...data }))}
            users={users}
          />
        </VStack>
      </ModalBody>
      <ModalFooter>
        <Button variant="ghost" mr={3} onClick={onClose}>
          Cancel
        </Button>
        <Button colorScheme="blue" onClick={onSave} isLoading={isLoading}>
          Add Task
        </Button>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default TaskModal;
